import Image from './Image';

export default Image;
export { default as ImageAvatar } from './ImageAvatar';
